import { useContext } from 'react'

import { AppBarContext } from '../context'

export function useAppBarContext() {
  return useContext(AppBarContext)
}
